import { createStorefrontApiClient } from '@shopify/storefront-api-client';

const initShopifyClient = (storeDomain, publicAccessToken, apiVersion = '2024-10') => {
    if (!storeDomain) {
        console.error('Missing required option for ArticleFilter component: storeDomain');
        return null;
    }
    if (!publicAccessToken) {
        console.error('Missing required option for ArticleFilter component: publicAccessToken');
        return null;
    }

    return createStorefrontApiClient({
        storeDomain,
        publicAccessToken,
        apiVersion
    });
};

export default initShopifyClient;